export default {
  meta: {
    title: '数据报表',
    url: '/report/manage', // 埋点用，记录所属模块
    // eventId: 'e9da7c8f-963b-410e-b209-18f9c06df0c6'
  },
};
